import { useKeepFocusedFieldVisible } from '../hooks/useKeepFocusedFieldVisible';
import { usePublishVisualViewport } from '../hooks/useVisualViewport';

/**
 * Makes room for the on-screen keyboard on phones and tablets, for the whole app. Mounted once,
 * at the app root. It publishes the visible part of the screen as CSS variables (read by the
 * classes in `keyboardAwareClasses`, so bottom sheets, full-screen pages and the bars fixed to
 * the bottom sit above the keyboard), and scrolls a focused field into view once the keyboard
 * has opened. On a desktop it does nothing.
 */
export const KeyboardAwareLayout = () => {
  usePublishVisualViewport();
  useKeepFocusedFieldVisible();
  return null;
};
